// This file was automatically generated from passwordHelpNoVerifiedEmail.html.
// Please don't edit this file by hand.

goog.provide('el8.template.multiuser_access.passwordHelpNoVerifiedEmail');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.multiuser_access.passwordHelpNoVerifiedEmail.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8FormBox el8BoxWithHeading el8FaxFlow mt15p"><img src="/static/images/e-circle-blue.png?v=20160729" style="width:40px;position:absolute;right:25px;top:20px;" /><h3 class="el8BrandColor el8LightWeight el8AlignCenter">Forgot your password?  No worries.</h3><div class="el8MdSpacer"></div><div class="w80p el8CenterBlock"><h4 class="el8AlignCenter mbMd">Since you have already entered the reference code, you may view the documents in the patient chart as PDFs only.</h4><div class="el8MdSpacer"></div><div class="el8AlignCenter"><a href="', soy.$$escapeHtml(opt_data.viewDocumentUrl), '" class="el8Btn el8BtnPrimary">View Documents</a></div></div><div class="el8MdSpacer"></div></div></div>');
  if (!opt_sb) return output.toString();
};
